import { render, staticRenderFns } from "./blogger_credits.vue?vue&type=template&id=934f7146&scoped=true"
import script from "./blogger_credits.vue?vue&type=script&lang=ts"
export * from "./blogger_credits.vue?vue&type=script&lang=ts"
import style0 from "./blogger_credits.vue?vue&type=style&index=0&id=934f7146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934f7146",
  null
  
)

export default component.exports